// import external dependencies
import 'jquery';
//import 'bootstrap';
import * as bootstrap from 'bootstrap';


// Import everything from autoload
//import './autoload/**/*'
//import './autoload/**/*.js'
import './autoload/_bootstrap.js';
import './autoload/_bootstrap-datepicker.js';





// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleProduct from './routes/singleProduct';
import cart from './routes/cart';
import checkout from './routes/checkout';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  checkout,
  cart,
  singleProduct,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// clicks on .rounded-shop-button takes them to the url in data-target
jQuery(document).on('click', '.rounded-shop-button .button-content', function (e) {
  console.log('rounded-shop-button clicked');
  e.preventDefault();
  const targetUrl = jQuery(this).data('target');
  if (targetUrl) {
    window.location = targetUrl; 
  }
}
);
